import ReviewsTab from './reviewsTab';

export default ReviewsTab;
